import Button from '@cpg-its/ads.common.button';
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { paginationStyles } from '../../global/constants/theme/styles/components/pagination';
import { SearchProps } from '../../pages/arc/models/arc-epi-props';
import { TcsmStates } from '../../root/tcsm-model';
import { SearchAppContext } from '../models/search-models';
import { setCurrentPage } from '../slices/backend-search-slice';

export function BackendPagination() {
    const classes = paginationStyles();
    const app = useContext(SearchAppContext);
    const searchSettings = useSelector<TcsmStates, SearchProps>(state => state?.epiProps?.searchSettingsState?.epiContent);
    const currentPage = useSelector<TcsmStates, number>(state => state?.backendSearchStates[app]?.currentPage);
    const totalPage = useSelector<TcsmStates, number>(state => state?.backendSearchStates[app]?.totalPage);
    const countPerPage = useSelector<TcsmStates, number>(state => state?.backendSearchStates[app]?.pageSize);
    const totalCount = useSelector<TcsmStates, number>(state => state?.backendSearchStates[app]?.totalCount);
    const dispatch = useDispatch();
    const onClick = (next: boolean) => {
        dispatch(setCurrentPage(next ? currentPage + 1 : currentPage - 1, app));
    };

    const getItemRage = () => {

        if (totalCount <= currentPage * countPerPage) {
            return `${(currentPage - 1) * countPerPage + 1} - ${totalCount}`;
        }
        if (totalCount === (currentPage - 1) * countPerPage + 1) {
            return `${totalCount}`;
        }

        return `${(currentPage - 1) * countPerPage + 1} - ${currentPage * countPerPage}`;
    };

    return (
        <div className={`${classes.paginationContainer} table-pagination`}>
            <div className='pagination-inner'>
                <Button icon='back' type='button' text={searchSettings?.previousButton} buttonStyle='secondary' disabled={currentPage === 1} onClick={() => onClick(false)} />

               
                <div className='pagination-text'><p>{`${getItemRage()} of ${totalCount}`}</p></div>

                <Button rightIcon icon='forward' type='button' text={searchSettings?.nextButton} buttonStyle='secondary' disabled={currentPage === totalPage}  onClick={() => onClick(true)} />
            </div>
        </div>

    );
}
